import Vue from 'vue'
import { set } from '@/utils/vuex'
import resetState from '@/utils/resetState'
import { initialState } from './state'

export default {
  selectAsphaltMix(state, asphaltMixId) {
    Vue.set(state, 'selectedAsphaltMixId', asphaltMixId)
  },
  selectPlant(state, plantId) {
    Vue.set(state, 'selectedPlantId', plantId)
  },
  updateAsphaltMixes(state, asphaltMixes) {
    Vue.set(state, 'asphaltMixes', asphaltMixes)
  },
  updateColdBinReadings(state, coldBinReadings) {
    Vue.set(state, 'coldBinReadings', coldBinReadings)
  },
  updateHotBinReadings(state, hotBinReadings) {
    Vue.set(state, 'hotBinReadings', hotBinReadings)
  },
  updateLabResults(state, labResults) {
    Vue.set(state, 'labResults', labResults)
  },
  updateTemperatureReadings(state, temperatureReadings) {
    Vue.set(state, 'temperatureReadings', temperatureReadings)
  },
  updatePlants(state, plants) {
    Vue.set(state, 'plants', plants)
  },

  clearState(state) {
    resetState(state, initialState)
  },
}
